<template>
  <el-card shadow="never">
    <template slot="header">
      <el-steps :active="active" align-center>
        <el-step title="Type Of Document"> </el-step>
        <el-step title="Details"> </el-step>
        <el-step title="Anvil"> </el-step>
      </el-steps>
    </template>
    <div v-if="active === 0">
      <el-select style="width: 20rem" size="large" v-model="options" placeholder="Select the type" @visible-change="checkStatus">
        <el-option value="PreLien" label="PRE LIEN NOTICE"></el-option>
        <el-option value="Lien" label="LIEN NOTICE"></el-option>
        <el-option value="NonRenewal" label="NON RENEWAL"></el-option>
        <el-option :disabled="!enable" value="CreditCard" label="CREDIT CARD AUTHORIZATION"></el-option>
      </el-select>
      <el-button style="margin-top: 12px" @click="next" :loading="loading" :disabled="!status">Next step</el-button>
    </div>
    <div v-else-if="active === 1">
      <el-card v-show="['PreLien', 'Lien'].includes(options)" shadow="never" v-loading="loading">
        <el-form label-position="left" label-width="150px" style="max-width: 460px">
          <el-form-item label="Contents of Unit">
            <el-input v-model="body" type="textarea" :maxlength="80" :rows="4" />
          </el-form-item>
          <el-form-item label="Pre-lien amount">
            <el-checkbox v-model="skipPreviousPreLienAmount">
              Recompute instead of using previous document amount
            </el-checkbox>
          </el-form-item>
          <el-button style="margin-top: 12px" type="warning" plain @click="() => (active -= 1)">
            Back
          </el-button>
          <el-button style="margin-top: 12px" @click="next">Next step</el-button>
        </el-form>
      </el-card>
      <el-card v-show="options === 'NonRenewal'" shadow="never" v-loading="loading">
        <el-form label-position="left" label-width="150px" style="max-width: 460px">
          <el-form-item label="End date:">
            <el-date-picker v-model="nonRenewalEndDate" :picker-options="nonRenewalEndDateOptions" @change="checkNonRenewalEndDate" type="date" placeholder="Pick an End Date"></el-date-picker>
          </el-form-item>
          <el-button style="margin-top: 12px" type="warning" plain @click="() => (active -= 1)">
            Back
          </el-button>
          <el-button style="margin-top: 12px" @click="next" :disabled="!nonRenewalEndDateSatisfied">Next step</el-button>
        </el-form>
      </el-card>
      <el-card v-show="options === 'CreditCard' && braintreeCustomer" shadow="never" v-loading="loading">
        <el-form label-position="left" label-width="150px" style="max-width: 460px">
          <el-form-item label="Last 4 digits of Credit Card">
            <el-select v-model="token" placeholder="Select last 4 digits">
              <el-option v-for="item in getLastFourDigits" :key="item.key" :label="item.last4" :disabled="item.disabled"
                :value="item.key" />
            </el-select>
          </el-form-item>
          <el-button style="margin-top: 12px" type="warning" plain @click="() => (active -= 1)">
            Back
          </el-button>
          <el-button style="margin-top: 12px" @click="next">Next step</el-button>
        </el-form>
      </el-card>
    </div>
    <div v-else-if="active === 2" shadow="never">
      <div v-if="options !== 'CreditCard'" shadow="never">
        <PreLienAnvil v-if="signerUrl" :url="signerUrl" @completed="saveAgreement" />
        <el-button style="margin-top: 12px" type="warning" plain
          @click="() => options === 'Lien' ? (active -= 2) : (active -= 1)">
          Back
        </el-button>
        <el-button style="margin-top: 12px" type="primary" plain :loading="loading" :disabled="!agreementSigned"
          @click="preLienAnvilCompleted">
          Done
        </el-button>
      </div>
      <div v-else shadow="never">
        <el-result icon="success" title="Successfully requested to sign">
        </el-result>
      </div>
    </div>
  </el-card>
</template>


<script>
import PreLienAnvil from '@/components/PreLienAnvil';
import { differenceInCalendarDays, lastDayOfMonth } from 'date-fns';
import axios from 'axios';
import {
  UPLOAD_API,
  ADMIN_API_BASE,
  LEASING_API,
  NON_RENEWAL_TEMPLATE_ID,
  EMAIL_API_BASE,
  PRELIEN_TEMPLATE_ID,
  LIEN_TEMPLATE_ID,
  RS_ANVIL_API,
  CC_TEMPLATE_ID,
  PG_API_BASE,
} from '../env';
import RsAnvilApi from '../api/rsAnvilApi';
import anvilIntegration from '../utils/anvilIntegration';
import { getCustomerById } from '../api/customers';
import { createCustomerDocument } from '../api/documents';
import { getPreLienDueAmount, getLienDueAmount } from '../utils/pricing';
import getParsedTokenTitle from '../utils/keycloak';

export default {
  name: 'AutoDocument',
  components: { PreLienAnvil },
  props: {
    id: { type: String, required: true },
    customerInvoices: { type: Array, default: () => [] },
    unitRentals: { type: Array, default: () => [] },
    facility: { type: String, required: true },
  },
  watch: {
    async id() {
      await this.getCustomer();
    },
    async facility() {
      await this.getFacility();
    },
    options() {
      this.skipPreviousPreLienAmount = false;
    },
  },
  async mounted() {
    await this.getFacility();
    await this.getCustomer();
    this.enable = true;
  },
  data() {
    return {
      nonRenewalEndDateSatisfied: false,
      nonRenewalEndDateOptions: { disabledDate: this.nonRenewalDateValidator },
      nonRenewalEndDate: null,
      newDailyRate: 0,
      enable: false,
      loading: false,
      token: '',
      braintreeCustomer: null,
      facilityData: {},
      payloadInvalid: false,
      agreementSigned: false,
      status: false,
      active: 0,
      currentDate: new Date(),
      options: '',
      customer: {},
      body: '',
      skipPreviousPreLienAmount: false,
      selectedTitle: getParsedTokenTitle(this.$keycloak),
      payload: {},
      signerUrl: '',
      etchPacket: '',
      etchPacketLien: '',
      signerUrlLien: '',
    };
  },
  computed: {
    activeLease() {
      const [acLease] = this.customerInvoices.filter(lease => lease && !lease.future);
      return acLease;
    },
    getLastFourDigits() {
      const creditDocs = this.customer.docs.filter(item => item.type === 'CREDIT_CARD_AUTHORIZATION').map(item => item.referenceId);
      const last4Digits = this.braintreeCustomer && this.braintreeCustomer.creditCards ? this.braintreeCustomer.creditCards.map(item => ({ key: item.token, last4: item.last4, disabled: creditDocs.includes(item.token) })) : [];
      return last4Digits;
    },
  },
  methods: {
    /*
      Non Renewal end date can be:
        * greater than moveOut date if moveOut date is set
        * greater than today is moveOut date is not set
    */
    nonRenewalDateValidator(date) {
      const leaseEndDate = this.activeLease && this.activeLease.end ? new Date(this.activeLease.end) : null;
      if (leaseEndDate) {
        return date < leaseEndDate;
      }

      return date < new Date();
    },
    checkNonRenewalEndDate(date) {
      this.nonRenewalEndDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 9));
      this.nonRenewalEndDateSatisfied = true;
      this.newDailyRate = this.unitRentals.map(rental => this.computeNewDailyRate(rental)).reduce((a, b) => a + b, 0);
    },
    computeNewDailyRate(unitRental) {
      let newDailyRate = 0;
      const currentDate = unitRental.moveOut ? new Date(unitRental.moveOut) : new Date();
      const diffInDays = differenceInCalendarDays(this.nonRenewalEndDate, currentDate);
      if (diffInDays > 0) {
        const price = unitRental.updatedPrice ? unitRental.updatedPrice : unitRental.pricing.price;
        const lastDayDate = lastDayOfMonth(this.nonRenewalEndDate);
        const lastDay = lastDayDate.getDate();
        const unitLateFeeForOneDay = (price / lastDay);
        const penalty = this.facilityData.penalty / 100;
        newDailyRate = (unitLateFeeForOneDay + (penalty * unitLateFeeForOneDay));
      }
      return newDailyRate;
    },
    async getFacility() {
      const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.facilityData = facility.data;
    },
    async getCustomer() {
      this.customer = await getCustomerById(this.id, this.facility, this.$keycloak.token);
    },
    async getCustomerFromBraintree() {
      this.loading = true;
      const response = await axios.get(
        `${PG_API_BASE}/customer/${this.id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.braintreeCustomer = response.data.customer;
      this.loading = false;
    },
    validateSignerPayload() {
      if (this.options === 'CreditCard') {
        if (!this.customer.primaryContact) {
          this.customer.primaryContact = {
            name: this.customer.fullName,
          };
        }
        if (!this.customer.primaryContact.name || !this.customer.phone || !this.customer.city || !this.customer.state) {
          this.$message.warning({
            title: 'Failed',
            message: 'Customer Profile is missing required information.',
          });
          this.payloadInvalid = true;
          return;
        }
        return;
      }
      if (!this.customer.company || !this.customer.address || !this.customer.country || !this.customer.state || !this.customer.city || !this.customer.zip) {
        this.$message.error({
          title: 'Required',
          message: 'Customer required info is missing address info.',
        });

        this.payloadInvalid = true;
        return;
      }

      if (!this.facilityData.manager.name || !this.facilityData.manager.phone) {
        this.$message.error({
          title: 'Required',
          message: 'Missing required manager details',
        });
        this.payloadInvalid = true;
        return;
      }

      if (!this.activeLease.facility.addressInfo.addressLine1
        || !this.activeLease.facility.addressInfo.city
        || !this.activeLease.facility.addressInfo.state
        || !this.activeLease.facility.addressInfo.pinCode
        || !this.activeLease.facility.addressInfo.country
      ) {
        this.$message.error({
          title: 'Required',
          message: 'Facility address is missing',
        });
        this.payloadInvalid = true;
        return;
      }

      this.payloadInvalid = false;
    },
    async preparePayload() {
      const templateIdMap = {
        PreLien: PRELIEN_TEMPLATE_ID,
        Lien: LIEN_TEMPLATE_ID,
        CreditCard: CC_TEMPLATE_ID,
        NonRenewal: NON_RENEWAL_TEMPLATE_ID,
      };
      const response = await axios.get(`${RS_ANVIL_API}/cast/${templateIdMap[this.options]}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      const payloadFields = response.data.cast.fieldInfo.fields;

      const payloadTypeId = payloadFields.map(item => item.id);

      const [foundCard] = this.braintreeCustomer && this.braintreeCustomer.creditCards ? this.braintreeCustomer.creditCards.filter((item) => {
        if (item.token === this.token) {
          return item;
        }
      }) : [null];

      if (['Lien', 'PreLien'].includes(this.options)) {
        const pendingLineItemsResponse = await axios.get(`${LEASING_API}/v1/customer/${this.activeLease._id}/status`,
          {
            params: {
              tz: this.$root.state.facilityData.tz,
            },
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        const { creditLineItemsByPeriod } = pendingLineItemsResponse.data;

        this.activeLease.lienDueAmount = getLienDueAmount(
          creditLineItemsByPeriod,
          this.activeLease,
          this.$root.state.facilityData.offset,
        );
        this.activeLease.preLienDueAmount = getPreLienDueAmount(
          creditLineItemsByPeriod,
          this.customer.docs,
          this.activeLease,
          this.$root.state.facilityData.offset,
          {
            skipPreviousPreLienAmount: this.skipPreviousPreLienAmount,
          },
        );
      }
      const last4 = foundCard ? foundCard.last4 : null;
      try {
        const anvil = anvilIntegration(
          this.customer,
          this.facilityData,
          this.activeLease,
          this.selectedTitle,
          this.options,
          last4,
          this.body,
          this.unitRentals,
          {
            selectedEndDate: this.options === 'NonRenewal' ? this.nonRenewalEndDate : null,
            depositOnFile: this.options === 'NonRenewal' && this.activeLease && this.activeLease.depositPaid ? this.activeLease.depositPaid : 0,
            newDailyRate: this.options === 'NonRenewal' ? this.newDailyRate : 0,
          },
        );
        payloadTypeId.forEach((item) => {
          this.payload[item] = typeof anvil[item] === 'function' ? anvil[item]() : anvil[item];
        });
      } catch (error) {
        console.log(error);
        this.$message.error({
          message: error.message,
        });
      }
    },
    async createSignerDocument() {
      this.loading = true;

      await this.preparePayload();

      const anvilApi = new RsAnvilApi(this.$keycloak.token);

      const templateIdMap = {
        PreLien: PRELIEN_TEMPLATE_ID,
        Lien: LIEN_TEMPLATE_ID,
        NonRenewal: NON_RENEWAL_TEMPLATE_ID,
      };
      const templateId = templateIdMap[this.options];

      const signerName = this.$keycloak.tokenParsed.name;
      // if (this.options === 'PreLien') {
      //   signerName = this.payload.manager3;
      // } else if (this.options === 'NonRenewal') {
      //   signerName = this.$keycloak.tokenParsed.name;
      // } else {
      //   signerName = this.payload.managerName1;
      // }
      const response = await anvilApi.generatePreLienAndLienAgreement({
        payload: this.payload,
        name: signerName,
        customerId: this.id,
        options: this.options,
        templateId,
      });

      this.etchPacket = response.data.data.createEtchPacket;

      const signerEid = this.etchPacket.documentGroup.signers[0].eid;
      const documentEid = this.etchPacket.documentGroup.eid;
      const rsAnvilApi = new RsAnvilApi(this.$keycloak.token);

      const responseUrl = await rsAnvilApi.getSignerEmbedUrl(signerEid, documentEid);
      this.signerUrl = responseUrl.url;

      this.body = null;
      this.loading = false;
    },
    async createCreditCardDocument() {
      this.loading = true;
      await this.preparePayload();

      const anvilApi = new RsAnvilApi(this.$keycloak.token);

      const response = await anvilApi.generateCCAgreement({
        payload: this.payload,
        name: this.customer.primaryContact ? this.customer.primaryContact.name : this.customer.fullName,
        customerId: this.id,
      });

      this.etchPacket = response.data.data.createEtchPacket;
      const documentEid = this.etchPacket.eid;
      const documentGroupEid = this.etchPacket.documentGroup.eid;

      await this.uploadDocument(response, documentEid, documentGroupEid);
      this.loading = false;
      this.next();
      this.preLienAnvilCompleted();
    },
    async saveAgreement() {
      this.loading = true;
      const anvilClient = new RsAnvilApi(this.$keycloak.token);

      const documentEid = this.etchPacket.eid;
      const documentGroupEid = this.etchPacket.documentGroup.eid;
      const agreementBuffer = await anvilClient.downloadAgreement(documentGroupEid);

      const formData = new FormData();
      const buffer = new Uint8Array(agreementBuffer.data.data);
      const blob = new Blob([buffer], { type: 'application/pdf' });
      formData.append('document', blob, `${documentEid}.pdf`);

      const response = await axios.post(UPLOAD_API, formData, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      await this.uploadDocument(response, documentEid, documentGroupEid);

      this.agreementSigned = true;
      this.preLienAnvilCompleted();
      this.loading = false;
    },
    async uploadDocument(response, documentEid, documentGroupEid) {
      if (!this.customer.docs) {
        this.customer.docs = [];
      }
      if (this.options === 'CreditCard') {
        this.customer.docs = this.customer.docs.filter(item => item.referenceId !== this.token || !item.referenceId);
      }
      const templateIdMap = {
        PreLien: PRELIEN_TEMPLATE_ID,
        Lien: LIEN_TEMPLATE_ID,
        NonRenewal: NON_RENEWAL_TEMPLATE_ID,
        CreditCard: CC_TEMPLATE_ID,
      };
      const documentTypeMap = {
        PreLien: 'PRELIMINARY_LIEN_NOTICE',
        Lien: 'NOTICE_OF_LIEN',
        NonRenewal: 'NON_RENEWAL',
        CreditCard: 'CREDIT_CARD_AUTHORIZATION',
      };
      const customerDocumentPayload = {
        createdAt: new Date(),
        createdBy: this.$keycloak.tokenParsed.email,
        documentEid,
        documentGroupEid,
        ...(this.options !== 'CreditCard' ? { url: response.data.url } : {}),
        documentUrl: this.etchPacket.detailsURL,
        type: documentTypeMap[this.options],
        templateId: templateIdMap[this.options],
        referenceId: this.options === 'CreditCard' ? this.token : this.activeLease._id,
        ...(this.options === 'PreLien' ? { preLienAmount: this.activeLease.preLienDueAmount } : {}),
      };
      await createCustomerDocument(
        this.id,
        customerDocumentPayload,
        true,
        this.$keycloak.token,
      );

      await this.getCustomer();
    },
    async sendEmail(url) {
      const attachment = [];
      attachment.push({
        name: this.options === 'PreLien' ? 'PreLien Notice.pdf' : 'Lien Notice.pdf',
        type: 'application/pdf',
        url,
      });
      await axios.post(`${EMAIL_API_BASE}/send/email`, {
        from: this.$keycloak.tokenParsed.email,
        to: this.payload.email,
        subject: this.options === 'PreLien' ? 'PreLien Notice' : 'Lien Notice',
        body: this.body,
        attachments: attachment,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
    },
    checkStatus() {
      if (this.customerInvoices.length === 0) {
        this.$message.warning({
          message: 'Customer does not have any active lease.',
        });
        return;
      }

      this.status = false;
      this.status = ['CreditCard', 'NonRenewal'].includes(this.options);

      const allowedPreLienStatuses = ['PRE_LIEN', 'LIEN'];
      if ((!allowedPreLienStatuses.includes(this.activeLease.status)) && this.options === 'PreLien') {
        this.$message.warning({
          message: `Active lease is not ${allowedPreLienStatuses.join(' | ')} status`,
        });
        return;
      } else if (allowedPreLienStatuses.includes(this.activeLease.status) && this.options === 'PreLien') {
        this.status = true;
      }

      if (this.activeLease.status !== 'LIEN' && this.options === 'Lien') {
        this.$message.warning({
          message: 'Active lease is not in Lien status',
        });
      } else if (this.activeLease.status === 'LIEN' && this.options === 'Lien') {
        if (this.customer.docs.length === 0) {
          this.status = false;
          this.$message.warning({
            message: 'PreLien notice date not found!',
          });
        } else {
          let found = false;
          this.customer.docs.forEach((item) => {
            if (item.type === 'PRELIMINARY_LIEN_NOTICE' && item.referenceId === this.activeLease._id) {
              // this.status = false;
              found = true;
            }
          });
          if (!found) {
            this.$message.warning({
              message: 'PreLien notice date not found, setting to 14 days ago!',
            });
          }
        }
        this.status = true;
      }
    },
    async next() {
      switch (this.active) {
        case 0:
          this.validateSignerPayload();
          if (!this.payloadInvalid) {
            if (this.options === 'CreditCard') {
              await this.getCustomerFromBraintree();
            }
            this.active += 1;
          }
          break;
        case 1:
          this.loading = true;
          if (['Lien', 'PreLien', 'NonRenewal'].includes(this.options)) {
            await this.createSignerDocument();
          } else if (this.options === 'CreditCard') {
            await this.createCreditCardDocument();
          }
          this.loading = false;
          this.active += 1;
          break;
        case 2:
          this.active += 1;
          break;
        default:
          break;
      }
    },
    preLienAnvilCompleted() {
      this.$emit('completed');
    },
  },
};

</script>

<style>
.el-alert {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoDocument.vue